const hiddenGalleryPageContent = '.be-ix-link-block, header, footer, #main-content, .skip-to-main-content, .usabilla_live_button_container';

const hideGalleryPageContentFromScreenReader = () => {
  const selectors = document.querySelectorAll(hiddenGalleryPageContent);
  [].map.call(selectors, (item) => {
    item.setAttribute('aria-hidden', 'true');
    item.classList.add('hidden');
  });
  const modalDiv = document.querySelector('.gallery-modal-container');
  const modalWrapper = document.querySelector('body');
  modalWrapper.append(modalDiv);
};

const reenableGalleryPageContent = () => {
  const selectors = document.querySelectorAll(hiddenGalleryPageContent);
  [].map.call(selectors, (item) => {
    item.removeAttribute('aria-hidden');
    item.classList.remove('hidden');
  });
  const modalDiv = document.querySelector('.gallery-modal-container');
  const modalWrapper = document.querySelector('.media-gallery-container');
  modalWrapper.append(modalDiv);
};

export {
  hideGalleryPageContentFromScreenReader,
  reenableGalleryPageContent,
};
